var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoodles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 754,
    height: 293,
    viewBox: "0 0 754 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H754V292.69H0V0Z",
    fill: "#40499D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H754V292.69H0V0Z",
    fill: "black",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_39619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.334 197.012C509.682 147.505 560.883 102.317 645.922 102.317",
    stroke: "#B062FF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.404 30.3184C359.632 29.1071 380.559 29.7364 390.444 41.9441",
    stroke: "#9B93FF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.698 82.3333C435.757 125.266 436.579 210.803 450.477 229.324C471.737 257.656 493.749 228.669 549.618 188.88C603.911 150.215 621.148 149.071 688.526 137.425",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.344 233.522C256.366 210.602 235.506 150.156 255.883 91.7255C281.354 18.6873 335.259 -37.1292 397.044 -2.71636C446.636 24.9054 457.411 85.8257 460.107 92.4041",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.246 167.742C365.1 235.931 381.329 383.637 271.134 482.386C160.939 581.135 151.467 651.714 160.505 674.66",
    stroke: "#B062FF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.594 479.471C246.631 449.938 309.646 373.941 313.416 306.21C318.129 221.546 279.527 67.738 346.82 67.738C403.511 67.738 399.323 247.96 415.327 280.271C434.81 319.609 463.854 311.423 521.032 263.501C594.338 202.062 622.376 192.607 679.766 180.828",
    stroke: "#3AB8FF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.347 329.185C404.218 349.473 448.23 377.497 485.664 348.822C532.458 312.979 605.478 207.266 758.536 245.196",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.427 -350.751C727.548 -326.771 803.718 -230.419 725.034 -221.517C653.622 -213.438 600.388 -321.945 480.165 -202.265M428.243 -44.4261C428.243 -87.9619 450.496 -122.435 460.104 -134.096C533.51 -223.18 713.257 -227.654 785.079 -57.4795",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.13 65.8193C608.043 75.2707 549.326 71.0621 526.722 24.7246C498.466 -33.1973 536.333 -99.6756 614.239 -91.8577C676.564 -85.6033 678.181 -38.398 713.605 0.878835C739.855 29.9831 756.456 61.661 822.437 52.3016",
    stroke: "#3AB8FF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.248 416.905C769.687 443.937 827.785 364.025 862.129 320.708C896.474 277.391 976.757 154.781 1067.52 281.532",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-142.753 416.905C-77.3138 443.937 -19.2159 364.025 15.1284 320.708C49.4726 277.391 129.756 154.781 220.523 281.532",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.6 459.455C841.156 430.191 887.482 379.764 900.92 341.295C917.944 292.56 957.115 261.868 987.28 270.513C1052.56 289.22 1058.04 381.462 984.564 414.412C911.089 447.362 915.353 398.852 773.269 537.802",
    stroke: "#9B93FF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-89.4005 459.454C-5.84414 430.19 40.4821 379.764 53.9201 341.295C70.9441 292.56 111.454 268.45 141.619 277.095C206.896 295.802 211.039 381.461 137.564 414.411C64.0889 447.362 68.353 398.851 -73.7314 537.802",
    stroke: "#9B93FF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.01 296.013C1120.21 327.834 1105.64 405.184 997.697 460.022C862.768 528.569 771.913 573.376 771.913 641.898",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.009 296.013C273.215 327.834 258.641 405.184 150.697 460.022C15.7679 528.569 -75.0867 573.376 -75.0867 641.898",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.822 -20.3305C569.34 -47.9189 602.325 -52.3691 618.128 -51.1457C668.31 -44.6445 670.229 -4.93028 644.409 17.0291C618.588 38.9886 556.924 14.155 563.822 -20.3305Z",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.617 17.3238C479.745 19.6348 522.352 58.1039 501.323 99.3153",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.565 71.9775C89.7487 88.4316 75.8015 112.245 28.8825 118.604",
    stroke: "#3AB8FF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.625 369.181C553.049 359.931 571.514 302.081 599.93 302.081C632.11 302.081 569.228 373.482 599.93 377.888C638.299 383.393 675.689 254.311 703.645 288.614C720.887 309.771 673.746 356.67 709.664 372.922C732.968 383.467 783.517 350.022 801.262 298.99",
    stroke: "#9B93FF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.694 23.8425C656.933 98.1667 734.01 78.0082 734.01 157.88",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.324 57.8916C727.742 74.5352 744.858 93.6996 784.025 91.221",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0459 -146.82C92.7911 -187.11 152.414 -209.884 192.363 -159.414C289.499 -36.6989 130.114 144.971 221.829 229.028",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80.616 129.268C-28.4592 170.626 55.2667 181.129 114.049 129.268C169.944 79.9527 148.004 10.6737 132.725 -60.4771C122.63 -107.486 127.882 -184.865 124.979 -217.638C119.046 -284.636 73.9858 -297.129 46.1195 -275.531C18.2532 -253.932 -25.3672 -212.345 -50.4808 -65.2207C-56.1698 -28.9126 -64.8154 17.414 -38.7499 25.4505C-12.7893 33.4547 32.7788 22.0208 41.4606 -55.8185",
    stroke: "#9B93FF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.6451 81.3954C101.428 95.6672 80.6348 -21.9811 80.6348 -54.1247C80.6348 -86.2683 82.3284 -160.762 86.2668 -194.727C90.2053 -228.691 56.1554 -249.697 29.2632 -183.377C2.37088 -117.057 3.85409 -51.7955 -11.7731 -28.3336",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.383 129.269C818.54 170.627 889.731 209.928 966.935 147.081C1010.56 111.568 988.815 102.679 971.979 -51.4139C963.946 -124.934 971.979 -184.736 971.979 -217.638C971.979 -277.012 920.985 -297.129 893.119 -275.53C865.253 -253.932 821.632 -212.344 796.519 -65.2199C790.83 -28.9119 782.184 17.4148 808.25 25.4513C834.21 33.4554 867.751 26.4253 876.433 -51.414",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.354 81.3962C971.127 158.6 920.096 6.18256 927.634 -54.1238C935.172 -114.43 937.925 -155.976 941.864 -189.94C945.802 -223.905 919.799 -237.436 888.418 -207.473C857.036 -177.511 850.853 -51.7947 835.226 -28.3328",
    stroke: "#4A3AFF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.39697 272.945C-26.6929 268.106 -59.1198 248.485 -59.1197 213.57C-59.1197 189.957 -21.772 210.416 17.3219 213.57C67.7185 217.636 129.168 193.962 156.06 150.257",
    stroke: "#9B93FF",
    strokeWidth: 19.481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612.931,
    cy: -7.3266,
    r: 11.3921,
    fill: "#B062FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.127,
    cy: 124.89,
    r: 11.3921,
    fill: "#4A3AFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.528,
    cy: 189.008,
    r: 11.3921,
    fill: "#3AB8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.976,
    cy: 300.727,
    r: 11.3921,
    fill: "#B062FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.884,
    cy: 130.989,
    r: 11.3921,
    fill: "#9B93FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_39619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 754,
    height: 293,
    rx: 33.88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoodles);
export default __webpack_public_path__ + "static/media/doodles.6d3411994c068629a43110876447ac11.svg";
export { ForwardRef as ReactComponent };